// A label/value list for the console's detail screens, in the same register as
// the account screen's facts: small muted label, value beside it, one row each.

import type { ReactNode } from "react";

export function Facts({ children, ...rest }: { children: ReactNode; "data-testid"?: string }) {
  return (
    <dl className="admin-facts admin-facts-grid" {...rest}>
      {children}
    </dl>
  );
}

export function Fact({
  label,
  children,
  ...rest
}: {
  label: string;
  children: ReactNode;
  "data-testid"?: string;
}) {
  return (
    <div className="admin-fact" {...rest}>
      <dt className="admin-fact-k">{label}</dt>
      <dd className="admin-fact-v">{children}</dd>
    </div>
  );
}
